import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { Subscription, debounceTime, filter, retry } from 'rxjs'
import { BookingService } from 'src/app/modules/booking/services/booking.service'
import { ActivatedRoute } from '@angular/router'

@Component({
	selector: 'app-wallet-filter',
	templateUrl: './wallet-filter.component.html',
	styleUrls: ['./wallet-filter.component.scss'],
})
export class WalletFilterComponent implements OnInit {
	@Output() emitFilter = new EventEmitter()
	@Output() emitfilterCount = new EventEmitter()
	filterForm = new FormGroup({
		serviceProviderId: new FormControl(null),
		branchId: new FormControl(null),
	})
	branchesListFilter: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		countryId: null,
		serviceProviderId: null,
		branchId: null,
	}
	@Input() filterData: any = {
		paging: { pageNumber: 1, pageSize: 10 },
		searchText: '',
		branchId: null,
		countryId: null,
		organizationId: this.filterForm.controls['serviceProviderId'],
	}
	country = this.ActivatedRoute.snapshot.queryParams['country'] || null
	subscription = new Subscription()
	keyWord = new FormControl('')
	keyWordBranch = new FormControl('')
	showList = false
	showBranchList = false
	serviceProviders: any = []
	filterCount = 0
	branchesList: any = []

	constructor(
		public translate: TranslateService,
		private bookingService: BookingService,
		private ActivatedRoute: ActivatedRoute
	) {}

	ngOnInit(): void {
		this.getBussinessNames()
		this.searchOnSelect(this.keyWord)
		this.searchOnSelect(this.keyWordBranch)

		this.filterForm.valueChanges.subscribe((val) => {
			this.filterCount = 0
			for (let value in val) {
				if (
					this.getController(value).value ||
					this.getController(value).value == 0
				)
					this.filterCount += 1
				else if (this.getController(value).value?.length) this.filterCount += 1
			}
		})
	}
	ngOnChanges() {
		this.getBussinessNames()
	}

	searchOnSelect(keyWordSearch: any) {
		keyWordSearch.valueChanges
			.pipe(
				filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
				debounceTime(700),
				retry(-1)
			)
			.subscribe((res: any) => {
				keyWordSearch == this.keyWord
					? this.getBussinessNames()
					: this.getBranches()
			})
	}

	getBussinessNames() {
		this.subscription.add(
			this.bookingService
				.getBussinessNames(this.country, this.keyWord.value)
				.subscribe((res: any) => {
					this.serviceProviders = res?.result?.items
				})
		)
	}

	getBranches() {
		if (this.getController('serviceProviderId').value) {
			this.branchesListFilter.serviceProviderId =
				this.getController('serviceProviderId').value
			this.branchesListFilter.searchText = this.keyWordBranch.value

			this.subscription.add(
				this.bookingService
					.SearchByServiceProviders(this.branchesListFilter)
					.subscribe((res: any) => {
						this.branchesList = res?.result?.items
					})
			)
		}
	}

	submit() {
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.emitFilter.emit(this.filterData)
		this.emitfilterCount.emit(this.filterCount)
	}

	resetFilter() {
		this.filterForm.reset()
		this.keyWord.setValue('')
		this.keyWordBranch.reset()
		this.branchesList = []
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.getBussinessNames()
		this.emitFilter.emit(this.filterData)
		this.emitfilterCount.emit(this.filterCount)
	}
	getController(controlName: string) {
		return (this.filterForm as FormGroup).controls[controlName]
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
